import { DatePicker } from "@p0security/ui";
import config from "rc-picker/lib/generate/dateFns";

export const CustomDatePicker = DatePicker.generatePicker<Date>(config);
